import { AccountPosition } from '../../type';

export const sumPcPortInt = (positionLines: AccountPosition | AccountPosition[] | null | undefined) => {
  if (positionLines && Array.isArray(positionLines) && positionLines.length > 0) {
    const result = positionLines.reduce((acc, line) => acc + (line['GES_ESTIM_D.PC_PORT_INT'] ?? 0), 0);
    return result;
  }
  return 0;
};
